module.exports = __webpack_public_path__ + "static/media/__startap.c963b736.svg";